export default function StatsSection() {
  const stats = [
    { number: '20,000+', label: 'Products Listed', icon: 'ri-store-2-line' },
    { number: '300+', label: 'Verified Sellers', icon: 'ri-shield-check-line' },
    { number: '30+', label: 'Buying Guides', icon: 'ri-book-open-line' },
    { number: 'Weekly', label: 'Updated Content', icon: 'ri-refresh-line' },
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          {/* Left */}
          <div className="lg:w-[55%]">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-foreground-700 text-xs font-semibold rounded-md mb-6 whitespace-nowrap">
              Updated Weekly
            </span>
            <h2 className="text-foreground-950 text-4xl md:text-5xl lg:text-6xl font-bold font-heading leading-[1.1] mb-10">
              20,000+ Products
              <br />
              300+ Verified Sellers
              <br />
              Weekly Guides
            </h2>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 h-13 px-8 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                View Full Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 h-13 px-8 border border-foreground-300 text-foreground-800 rounded-full font-semibold text-sm hover:bg-foreground-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Read Buying Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-file-text-line"></i>
                </span>
              </a>
            </div>
          </div>

          {/* Right - Stats Grid */}
          <div className="lg:w-[45%] grid grid-cols-2 gap-4 md:gap-6">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col items-start gap-3"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100">
                  <i className={`${stat.icon} text-lg text-foreground-800`}></i>
                </span>
                <span className="text-3xl md:text-4xl font-black text-foreground-950 font-heading">
                  {stat.number}
                </span>
                <span className="text-sm text-foreground-500 font-medium">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}